import React from 'react';
import { useTranslation } from 'react-i18next';

// constants
import colours from 'theme/atoms/colours';

// styles
import * as Styled from 'eCoach/_styles/ConvoPrep.style';
import * as Text from 'theme/components/Text.style';

interface ConversationStep {
  title: string;
  short_description: string;
  [key: string]: any;
}

interface ConversationItemProps {
  item: ConversationStep;
}

export default function ConversationItem({
  item: conversationStep,
}: ConversationItemProps): JSX.Element {
  const { t } = useTranslation('pageEcoach');

  return (
    <>
      <Text.H5>{conversationStep.title}</Text.H5>
      <Styled.Content>
        <Text.P2>
          {conversationStep.short_description}
          <b style={{ color: colours.blue[500] }}>{t('See more.')}</b>
        </Text.P2>
      </Styled.Content>
    </>
  );
}
